function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.8415 36.1625C10.3769 47.4821 24.8511 51.3605 36.1707 44.8251C47.4903 38.2898 51.3687 23.8155 44.8333 12.4959C38.298 1.17633 23.8237 -2.70204 12.5041 3.83332C1.18452 10.3687 -2.69386 24.843 3.8415 36.1625ZM8.60834 33.4122C13.6238 42.0993 24.732 45.0758 33.4191 40.0603C42.1063 35.0448 45.0827 23.9366 40.0672 15.2495C35.0517 6.56235 23.9435 3.58592 15.2564 8.60143C6.56926 13.6169 3.59283 24.7251 8.60834 33.4122Z",
  fill: "url(#paint0_angular_820_2760)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular_820_2760",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(41.3994 23.7789) rotate(164.932) scale(29.6392)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF2480"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF2480",
  stopOpacity: 0
})));
var SvgOneucloader = function SvgOneucloader(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOneucloader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oneucloader.7801aa66.svg";
export { ForwardRef as ReactComponent };